function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23 9.29A7.003 7.003 0 0 1 27.929 17C30.209 17 32 18.79 32 21a4 4 0 0 1-4 4H18a4 4 0 0 1-3.465-2H7A7 7 0 0 1 4.014 9.667 4 4 0 0 1 8 6h1v2H8a2 2 0 0 0-1.988 2.225l.088.791-.751.263A5.002 5.002 0 0 0 7 21h8.878l.236.667A2.001 2.001 0 0 0 18 23h10a2 2 0 1 0 0-4h-2.755l.47-1.333A5.001 5.001 0 0 0 23 11.417V9.289zM10.042 25a3 3 0 0 1 1.6.463c1.236.78 1.916 1.808 1.916 3.037 0 2.294-1.722 3.5-5 3.5-1.634 0-3.67-.211-6.115-.631a2.94 2.94 0 0 1-2.355-3.611l.121-.486A3 3 0 0 1 3.12 25h6.923zM2.15 27.758l-.122.485a.94.94 0 0 0 .753 1.155c2.342.402 4.27.602 5.777.602 2.294 0 3-.494 3-1.5 0-.474-.285-.906-.982-1.346a1 1 0 0 0-.534-.154H3.12a1 1 0 0 0-.97.758zM11 0h2v10h-2V0zm8 0h2v12h-2V0zm-4 0h2v6h-2V0zm0 8h2v2h-2V8zm-4 4h2v2h-2v-2zm8 2h2v2h-2v-2z"
});

var SvgPee = function SvgPee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "d6fd6ef487dc89aec4be3254c475058e.svg";
export { SvgPee as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/pee.svg
// module id = null
// module chunks = 